export enum RugbyUnionTryAttribute {
  Golden = 1062,
}
